module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_tablet_de@2x-434b2b9e4bcf334863bf3a206f41fcd4.png";